import Close from '@mui/icons-material/Close';
import { CircularProgress, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'aws-amplify';
import { format } from 'date-fns';
import React from 'react';
import { AuthContext } from '../../../contexts/auth-context';
import { NotificationData } from '../../../types';
import { captureError } from '../../../utils/capture-error';

export function NotificationItem(props: { data: NotificationData }) {
  // Props
  const { data } = props;
  // Context
  const {
    state: { impersonatedAgent },
  } = React.useContext(AuthContext);

  const queryClient = useQueryClient();
  // Mutation - Mark Notification As Read
  const mutation = useMutation({
    mutationFn: async () => {
      await API.post('ContractingAPI', '/notifications/read', {
        body: { NotificationId: data.NotificationId },
      });
    },
    onSuccess: async () => {
      // Refetch current notifications
      await queryClient.invalidateQueries({
        queryKey: ['/notifications/current'],
      });
    },
    onError: (error) => captureError({ data: { error } }),
  });

  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box>
        <Box
          sx={{
            fontFamily: 'Roboto Mono',
            fontSize: 14,
            textDecoration: 'italic',
            fontWeight: 'bold',
          }}
        >
          {format(new Date(data.CreatedDate || ''), 'MM/dd/yyyy')}
        </Box>
        <Box sx={{ fontSize: 14 }}>{data.Message} </Box>
      </Box>
      {impersonatedAgent?.AgtNo !== undefined ? null : (
        <Tooltip title="Dismiss" placement="left" arrow>
          <IconButton
            size="small"
            disabled={mutation.isLoading}
            onClick={() => mutation.mutate()}
          >
            {mutation.isLoading ? (
              <CircularProgress size={20} />
            ) : (
              <Close fontSize="small" />
            )}
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}
